// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__5j46T","additionalInfo":"AgreementModal_additionalInfo__1fmmn"};